import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Col, Collapse, Row } from "reactstrap";
import withRouter from "../../Components/Common/withRouter";
import SimpleBar from "simplebar-react";

// Import Data
import Navdata from "../LayoutMenuData";
//i18n
import { withTranslation } from "react-i18next";

const HorizontalLayout = (props) => {
  const navData = Navdata().props.children;
  let menuItems = [];
  let splitMenuItems = [];
  let menuSplitContainer = 17;
  navData.forEach(function (value, key) {
    if (value["isHeader"]) {
      menuSplitContainer++;
    }
    if (key >= menuSplitContainer) {
      let val = value;
      val.childItems = value.subItems;
      val.isChildItem = value.subItems ? true : false;
      delete val.subItems;
      splitMenuItems.push(val);
    } else {
      menuItems.push(value);
    }
  });

  const path = props.router.location.pathname;
  const [activeItemId, setActiveItemId] = useState(null);
  const [activeParentId, setActiveParentId] = useState(null);

  // Determine active item and parent based on current path
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    
    const findActiveItem = () => {
      let foundParentId = null;
      let foundItemId = null;
      let longestMatch = ""; // Track longest matching link

      // Check all menu items
      menuItems.forEach((item) => {
        // Check if main item matches (and it's longer than previous match)
        if (
          item.link &&
          item.link !== "#" &&
          (path === item.link || path.startsWith(item.link + "/")) &&
          item.link.length > longestMatch.length
        ) {
          foundItemId = item.id;
          foundParentId = null;
          longestMatch = item.link;
        }

        // Check if any subitem matches (and it's longer than previous match)
        if (item.subItems && Array.isArray(item.subItems)) {
          item.subItems.forEach((subItem) => {
            if (
              subItem.link &&
              (path === subItem.link || path.startsWith(subItem.link + "/")) &&
              subItem.link.length > longestMatch.length
            ) {
              foundItemId = subItem.id;
              foundParentId = item.id;
              longestMatch = subItem.link;
            }
          });
        }
      });

      setActiveItemId(foundItemId);
      setActiveParentId(foundParentId);
    };

    findActiveItem();
  }, [path, props.layoutType]);

  // Check if an item or its children are active
  const isItemActive = (item) => {
    if (item.id === activeItemId) return true;
    if (item.subItems && Array.isArray(item.subItems)) {
      return item.subItems.some((subItem) => subItem.id === activeItemId);
    }
    return false;
  };

  // Check if a subitem is active
  const isSubitemActive = (subItem) => {
    return subItem.id === activeItemId;
  };

  const closeDrawerOnMobile = () => {
    if (window.innerWidth <= 768) {
      document.body.classList.remove("vertical-sidebar-enable");
      document.body.classList.remove("vertical-collpsed");
    }
  };

  return (
    <React.Fragment>
      {(menuItems || []).map((item, key) => {
        return (
          <React.Fragment key={key}>
            {/* Main Header */}
            {!item["isHeader"] ? (
              item.subItems ? (
                <li className="nav-item">
                  <Link
                    onClick={item.click}
                    className={`nav-link menu-link ${isItemActive(item) ? "active" : ""}`}
                    to={item.link ? item.link : "/#"}
                    data-bs-toggle="collapse"
                    aria-expanded={isItemActive(item) || activeParentId === item.id}
                  >
                    <i className={item.icon}></i>{" "}
                    <span data-key="t-apps">{props.t(item.label)}</span>
                  </Link>
                  <span className="logo-sm color-black">
                    {/* <img src={logoSm} alt="" height="45" /> */}
                  </span>
                  <Collapse
                    className={
                      item.id === "baseUi" && item.subItems.length > 16
                        ? "menu-dropdown mega-dropdown-menu"
                        : "menu-dropdown"
                    }
                    isOpen={item.isExpanded || activeParentId === item.id}
                    id="sidebarApps"
                  >
                    {/* subItms  */}
                    {item.id === "baseUi" && item.subItems.length > 16 ? (
                      <React.Fragment>
                        <Row>
                          {item.subItems &&
                            (item.subItems || []).map((subItem, key) => (
                              <React.Fragment key={key}>
                                {key % 2 === 0 ? (
                                  <Col lg={4}>
                                    <ul className="nav nav-sm flex-column">
                                      <li className="nav-item">
                                        <Link
                                          onClick={closeDrawerOnMobile}
                                          to={item.subItems[key].link}
                                          className={`nav-link ${isSubitemActive(item.subItems[key]) ? "active" : ""}`}
                                        >
                                          {item.subItems[key].label}
                                        </Link>
                                      </li>
                                    </ul>
                                  </Col>
                                ) : (
                                  <Col lg={4}>
                                    <ul className="nav nav-sm flex-column">
                                      <li className="nav-item">
                                        <Link
                                          onClick={closeDrawerOnMobile}
                                          to={item.subItems[key].link}
                                          className={`nav-link ${isSubitemActive(item.subItems[key]) ? "active" : ""}`}
                                        >
                                          {item.subItems[key].label}
                                        </Link>
                                      </li>
                                    </ul>
                                  </Col>
                                )}
                              </React.Fragment>
                            ))}
                        </Row>
                      </React.Fragment>
                    ) : (
                      <ul className="nav nav-sm flex-column test">
                        {item.subItems &&
                          (item.subItems || []).map((subItem, key) => (
                            <React.Fragment key={key}>
                              {!subItem.isChildItem ? (
                                <li className="nav-item">
                                  <Link
                                    onClick={closeDrawerOnMobile}
                                    to={subItem.link ? subItem.link : "/#"}
                                    className={`nav-link ${isSubitemActive(subItem) ? "active" : ""}`}
                                  >
                                    {props.t(subItem.label)}
                                  </Link>
                                </li>
                              ) : (
                                <li className="nav-item">
                                  <Link
                                    onClick={subItem.click}
                                    className="nav-link"
                                    to="/#"
                                    data-bs-toggle="collapse"
                                  >
                                    {" "}
                                    {props.t(subItem.label)}
                                  </Link>
                                  <Collapse
                                    className="menu-dropdown"
                                    isOpen={subItem.stateVariables}
                                    id="sidebarEcommerce"
                                  >
                                    <ul className="nav nav-sm flex-column">
                                      {/* child subItms  */}
                                      {subItem.childItems &&
                                        (subItem.childItems || []).map(
                                          (subChildItem, key) => (
                                            <React.Fragment key={key}>
                                              {!subChildItem.isChildItem ? (
                                                <li className="nav-item">
                                                  <Link
                                                    onClick={
                                                      closeDrawerOnMobile
                                                    }
                                                    to={
                                                      subChildItem.link
                                                        ? subChildItem.link
                                                        : "/#"
                                                    }
                                                    className="nav-link"
                                                  >
                                                    {props.t(
                                                      subChildItem.label
                                                    )}
                                                  </Link>
                                                </li>
                                              ) : (
                                                <li className="nav-item">
                                                  <Link
                                                    onClick={subChildItem.click}
                                                    className="nav-link"
                                                    to="/#"
                                                    data-bs-toggle="collapse"
                                                  >
                                                    {" "}
                                                    {props.t(
                                                      subChildItem.label
                                                    )}
                                                  </Link>
                                                  <Collapse
                                                    className="menu-dropdown"
                                                    isOpen={
                                                      subChildItem.stateVariables
                                                    }
                                                    id="sidebarEcommerce"
                                                  >
                                                    <ul className="nav nav-sm flex-column">
                                                      {/* child subItms  */}
                                                      {subChildItem.childItems &&
                                                        (
                                                          subChildItem.childItems ||
                                                          []
                                                        ).map(
                                                          (
                                                            subSubChildItem,
                                                            key
                                                          ) => (
                                                            <li
                                                              className="nav-item apex"
                                                              key={key}
                                                            >
                                                              <Link
                                                                onClick={
                                                                  closeDrawerOnMobile
                                                                }
                                                                to={
                                                                  subSubChildItem.link
                                                                    ? subSubChildItem.link
                                                                    : "/#"
                                                                }
                                                                className="nav-link"
                                                              >
                                                                {props.t(
                                                                  subSubChildItem.label
                                                                )}
                                                              </Link>
                                                            </li>
                                                          )
                                                        )}
                                                    </ul>
                                                  </Collapse>
                                                </li>
                                              )}
                                            </React.Fragment>
                                          )
                                        )}
                                    </ul>
                                  </Collapse>
                                </li>
                              )}
                            </React.Fragment>
                          ))}
                      </ul>
                    )}
                  </Collapse>
                </li>
              ) : (
                <li className="nav-item">
                  <Link
                    onClick={closeDrawerOnMobile}
                    className={`nav-link menu-link ${isItemActive(item) ? "active" : ""}`}
                    to={item.link ? item.link : "/#"}
                  >
                    <i className={item.icon}></i>{" "}
                    <span>{props.t(item.label)}</span>
                  </Link>
                </li>
              )
            ) : (
              <li className="menu-title">
                <span data-key="t-menu">{props.t(item.label)}</span>
              </li>
            )}
          </React.Fragment>
        );
      })}
      {/* menu Items */}
    </React.Fragment>
  );
};

HorizontalLayout.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(HorizontalLayout));
